import { makeStyles } from "@mui/styles";

export const familyMedicalHistoryStyles = makeStyles({
  addFamilyMember: {
    textTransform: "none !important"
  }
});
